/* eslint-disable import/prefer-default-export */

export const transportationArrivals = {
    ARRIVAL_TIME_NOT_REQUIRED: 'arrivalTimeNotRequired',
    ARRIVAL_TIME_REQUIRED_IF_ENTERED: 'arrivalTimeRequiredIfEntered',
    ARRIVAL_TIME_ALWAYS_REQUIRED: 'arrivalTimeAlwaysRequired'
};


// WEBPACK FOOTER //
// ./src/constants/TransportationArrivals.js